import { Action } from '@ngrx/store';

export class TraderInfoAction implements Action {

    public static traderInfo: string = '[Report] trader_info';
    public static traderInfoError: string = '[Report] trader_info_error';
    public static traderInfoSuccess: string = '[Report] trader_info_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
